import React, { useEffect } from "react";
import moment from "moment";
import * as XLSX from "xlsx";

import LevelFilter from "./LevelFilter";
import ActionButtons from "./ActionButtons";
import { UserLevel } from "utils/constant";
import InputRadio from "components/atoms/InputRadio";

const FilterSection = ({
  currentUser,
  selectedLevel,
  setSelectedLevel,
  levelData,
  levelDataOptions,
  setLevelIdValue,
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  selectedFasyankes,
  setSelectedFasyankes,
  handleApplyFilter,
  tableRef,
  showData,
  showFilter,
  setShowFilter,
  levelIdValue,
  setSelectedKetenagaan,
  selectedKetenagaan,
  reportName = "LAPORAN",
}) => {
  useEffect(() => {
    if (currentUser.level === UserLevel.Fasyankes) {
      setLevelIdValue(currentUser?.fasyankes_id);
    } else if (currentUser.level === UserLevel.District) {
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.district_id);
    } else if (currentUser.level === UserLevel.Province) {
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.province_id);
    } else if (currentUser.level === UserLevel.National) {
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedFasyankes("");
    } else {
      setLevelIdValue("");
    }
  }, [selectedLevel]);

  const level =
    selectedLevel === UserLevel.National
      ? UserLevel.National
      : levelIdValue?.split("|")[1];

  const exportToExcel = () => {
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet 1" });
    XLSX.writeFile(
      wb,
      `${reportName}_${level}_${moment().format("DDMMYYYY")}.xlsx`
    );
  };

  const isEnableButton = () =>
    (selectedLevel === UserLevel.Fasyankes && !!selectedFasyankes) ||
    (selectedLevel === UserLevel.District && !!selectedDistrict) ||
    (selectedLevel === UserLevel.Province && !!selectedProvince) ||
    selectedLevel === UserLevel.National;

  return (
    <div className="filter">
      <div className="filter-header">
        <p>FILTER</p>
        <button
          className="btn_toggle_filter"
          onClick={() => setShowFilter(!showFilter)}
        >
          {showFilter ? <span>&#9650;</span> : <span>&#9660;</span>}
        </button>
      </div>
      {showFilter && (
        <div className="filter-body">
          <div className="filter-item">
            <div className="filter-label">
              <p>Ketenagaan</p>
            </div>
            <div className="filter-field">
              <InputRadio
                name={`ketenagaan_${selectedLevel}`}
                options={[
                  { label: "Puskesmas", value: "1" },
                  { label: "RS/Klinik", value: "2" },
                ]}
                onChange={(e) => {
                  const value = e.target.value;
                  console.log("Selected Ketenagaan:", value);
                  setSelectedKetenagaan(value);
                }}
                selectedOption={selectedKetenagaan}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-label">
              <p>Level</p>
            </div>
            <div className="filter-field">
              <LevelFilter
                currentUser={currentUser}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                levelData={levelData}
                levelDataOptions={levelDataOptions}
                setLevelIdValue={setLevelIdValue}
                selectedProvince={selectedProvince}
                setSelectedProvince={setSelectedProvince}
                selectedDistrict={selectedDistrict}
                setSelectedDistrict={setSelectedDistrict}
                selectedFasyankes={selectedFasyankes}
                setSelectedFasyankes={setSelectedFasyankes}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-field">
              <ActionButtons
                onApply={handleApplyFilter}
                onExport={exportToExcel}
                isExportVisible={showData}
                isDisabled={!isEnableButton()}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection;
